import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { throttle } from 'throttle-debounce';

export class ScrollDetector extends React.Component {
  static propTypes = {
    onWindowScroll: PropTypes.func,
  };

  componentDidMount() {
    if (this.props.onWindowScroll)
      window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    if (this.props.onWindowScroll)
      window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = throttle(500, e => {
    if (this.props.onWindowScroll) this.props.onWindowScroll(e);
  });

  render() {
    return (
      <Wrapper data-modal={true} onClick={this.props.onOuterClick}>
        {this.props.children}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  background-color: transparent;
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100vh;
  left: 0px;
  z-index: 100;
`;

ScrollDetector.propTypes = {
  children: PropTypes.node,
  onOuterClick: PropTypes.func,
};
